import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const hostname = window.location.hostname.toLowerCase();
const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
const hasDevMarker =
  hostname.includes('curiculumner-dev') ||
  hostname.includes('-dev') ||
  hostname.includes('.dev.') ||
  hostname.includes('dev.');
const isDevHost = isLocalHost || hasDevMarker;

const DEFAULT_DEV_CONFIG = {
  apiKey: 'AIzaSyDvUjJNHQegyw-9_sV0MJC5jkmU-bQQU0U',
  authDomain: 'curiculumner-dev.firebaseapp.com',
  projectId: 'curiculumner-dev',
  storageBucket: 'curiculumner-dev.firebasestorage.app',
  messagingSenderId: '311710820063',
  appId: '1:311710820063:web:cbba45cf3b90a051c76b6a',
  measurementId: 'G-NW8YNG5SPK'
};

const DEFAULT_PROD_CONFIG = {
  apiKey: 'AIzaSyBF5RlcQrQu5E7K8goGEcnEyy37je4UihM',
  authDomain: 'curiculumner.firebaseapp.com',
  projectId: 'curiculumner',
  storageBucket: 'curiculumner.firebasestorage.app',
  messagingSenderId: '610801436731',
  appId: '1:610801436731:web:a5ee1cdcb6fd2defbb741e',
  measurementId: 'G-NW8YNG5SPK'
};

const getConfigValue = (
  devValue: string | undefined,
  prodValue: string | undefined,
  defaultDevValue: string,
  defaultProdValue: string
) => {
  const normalizedDevValue = devValue?.trim();
  const normalizedProdValue = prodValue?.trim();

  if (isDevHost) return normalizedDevValue || defaultDevValue;
  return normalizedProdValue || defaultProdValue;
};

// Firebase-Konfiguration (DEV/PROD automatisch per Host)
const firebaseConfig = {
  apiKey: getConfigValue(
    process.env.REACT_APP_FIREBASE_API_KEY_DEV,
    process.env.REACT_APP_FIREBASE_API_KEY,
    DEFAULT_DEV_CONFIG.apiKey,
    DEFAULT_PROD_CONFIG.apiKey
  ),
  authDomain: getConfigValue(
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV,
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    DEFAULT_DEV_CONFIG.authDomain,
    DEFAULT_PROD_CONFIG.authDomain
  ),
  projectId: getConfigValue(
    process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV,
    process.env.REACT_APP_FIREBASE_PROJECT_ID,
    DEFAULT_DEV_CONFIG.projectId,
    DEFAULT_PROD_CONFIG.projectId
  ),
  storageBucket: getConfigValue(
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV,
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    DEFAULT_DEV_CONFIG.storageBucket,
    DEFAULT_PROD_CONFIG.storageBucket
  ),
  messagingSenderId: getConfigValue(
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DEV,
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    DEFAULT_DEV_CONFIG.messagingSenderId,
    DEFAULT_PROD_CONFIG.messagingSenderId
  ),
  appId: getConfigValue(
    process.env.REACT_APP_FIREBASE_APP_ID_DEV,
    process.env.REACT_APP_FIREBASE_APP_ID,
    DEFAULT_DEV_CONFIG.appId,
    DEFAULT_PROD_CONFIG.appId
  ),
  measurementId: getConfigValue(
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_DEV,
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    DEFAULT_DEV_CONFIG.measurementId,
    DEFAULT_PROD_CONFIG.measurementId
  )
};


// Firebase initialisieren
const app = initializeApp(firebaseConfig);

// Auth und Firestore exportieren
export const auth = getAuth(app);
export const db = getFirestore(app);

if (isDevHost && process.env.NODE_ENV !== 'production') {
  const missingDevVars = [
    'REACT_APP_FIREBASE_API_KEY_DEV',
    'REACT_APP_FIREBASE_APP_ID_DEV',
    'REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DEV'
  ].filter((envKey) => !(process.env as any)[envKey]);

  if (missingDevVars.length > 0) {
    console.warn('⚠️ DEV Firebase Variablen fehlen, PROD-Werte werden als Fallback genutzt:', missingDevVars);
  }
}

console.log('Firebase initialisiert mit Project ID:', firebaseConfig.projectId);
if (process.env.NODE_ENV !== 'production') {
  console.log('Firebase Host Detection:', { hostname, isDevHost, authDomain: firebaseConfig.authDomain });
}